import React, { useState, useEffect, useRef } from "react";
import maskDate from "../utils/maskDate";
import CustomButton from "./CustomButton";
// @ts-ignore
import { range } from "lodash";
import { getYear } from "date-fns";

export default function DateRangePicker({
  type = 0,
  placeholderStart = "YYYY年M月D日",
  placeholderEnd = "YYYY年M月D日",
  startDate = "", // YYYY-M-D
  endDate = "", // YYYY-M-D
  onChange = "",
  datePickerQuantity = 1,
  disabled = false,
}: any) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const getNextMonthDate = () => {
    const nextMonthDate = new Date();
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    return nextMonthDate;
  };
  const [currentDate2, setCurrentDate2] = useState(getNextMonthDate());
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth()); // Track the selected month
  const [selectedYear2, setSelectedYear2] = useState(
    currentDate2.getFullYear()
  );
  const [selectedMonth2, setSelectedMonth2] = useState(currentDate2.getMonth()); // Track the selected month
  const datepickerRef = useRef<any>(null);
  const [isOpenOptions, setIsOpenOptions] = useState(false);

  const getLastDayOfMonth = (date: any) => {
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return lastDay;
  };

  const years = range(getYear(new Date()), 1990, -1);
  const [year1Open, setYear1Open] = useState(false);
  const [year2Open, setYear2Open] = useState(false);

  const handleBlur = (event: any) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setYear1Open(false);
    }
  };

  const handleBlur2 = (event: any) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setYear2Open(false);
    }
  };
  
  useEffect(() => {
    setSelectedStartDate(startDate || null);
    setSelectedEndDate(endDate || null);

    if (startDate) {
      const start = new Date(startDate);

      // Calendar 1
      setCurrentDate(start);
      setSelectedYear(start.getFullYear());
      setSelectedMonth(start.getMonth());

      // Calendar 2
      const nextMonth = new Date(start);
      nextMonth.setMonth(start.getMonth() + 1);

      setCurrentDate2(nextMonth);
      setSelectedYear2(nextMonth.getFullYear());
      setSelectedMonth2(nextMonth.getMonth());
    }
    else if (endDate) {
      const end = new Date(endDate);

      const prevMonth = new Date(end);
      prevMonth.setMonth(end.getMonth() - 1);

      setCurrentDate(prevMonth);
      setSelectedYear(prevMonth.getFullYear());
      setSelectedMonth(prevMonth.getMonth());

      setCurrentDate2(end);
      setSelectedYear2(end.getFullYear());
      setSelectedMonth2(end.getMonth());
    }

  }, [startDate, endDate]);

  // Function to render days in the calendar for the selected month and year
  const renderCalendar = ({ year, month }: any) => {
    if (month == -1){
      year = year + 1
    }
    if (month == 12){
      year = year - 1
    }
    
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysArray = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      daysArray.push(<div key={`empty-${i}`}></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const day = new Date(Date.UTC(year, month, i));
      const dayString = day.toISOString().split("T")[0];
      let className =
        "text-sm alu-text-base-2 flex items-center justify-center cursor-pointer w-[36px] h-[36px] rounded-full text-dark-3 dark:text-dark-6 hover:bg-[#FFF3E5]";

      if (selectedStartDate && dayString === selectedStartDate) {
        className +=
          " bg-white dark:text-white rounded-r-none border-r-0 border border-[#FF861A]";
      }
      if (selectedEndDate && dayString === selectedEndDate) {
        className +=
          " bg-white dark:text-white rounded-l-none border-l-0 border border-[#FF861A]";
      }
      if (
        selectedStartDate &&
        selectedEndDate &&
        new Date(day) > new Date(selectedStartDate) &&
        new Date(day) < new Date(selectedEndDate)
      ) {
        className +=
          " bg-white border border-l-0 border-r-0 border-[#FF861A] dark:text-white rounded-none";
      }

      daysArray.push(
        <div
          key={i}
          className={className}
          data-date={dayString}
          onClick={() => handleDayClick(dayString)}
        >
          {i}
        </div>
      );
    }

    return daysArray;
  };

  const handleDayClick = (selectedDay: any) => {
    if (disabled) return;
    if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
      setSelectedStartDate(selectedDay);
      setSelectedEndDate(null);
    } else {
      if (new Date(selectedDay) < new Date(selectedStartDate)) {
        setSelectedEndDate(selectedStartDate);
        setSelectedStartDate(selectedDay);
      } else {
        setSelectedEndDate(selectedDay);
      }
    }
  };

  const updateInput = () => {
    if (selectedStartDate) {
      let dayMaskStart = selectedStartDate as any;
      if (type !== 0) dayMaskStart = maskDate(selectedStartDate, type);
      return dayMaskStart;
    } else {
      return "";
    }
  };

  const updateInput2 = () => {
    if (selectedEndDate) {
      let dayMaskEnd = selectedEndDate as any;
      if (type !== 0) dayMaskEnd = maskDate(selectedEndDate, type);
      return dayMaskEnd;
    } else {
      return "";
    }
  };

  const toggleDatepicker = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  const handleApply = () => {
    onChange(selectedStartDate, selectedEndDate);
    setIsOpen(false);
  };

  const handleClear = () => {
    setSelectedEndDate(null);
    setSelectedStartDate(null);
    onChange(null, null);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleDocumentClick = (e: any) => {
    if (datepickerRef.current && !datepickerRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  const handleYearChange = (value: any) => {
    const newYear = value;
    setSelectedYear(newYear);
    setCurrentDate(new Date(newYear, selectedMonth)); // Update the calendar with selected year
  };

  const handleMonthChange = (value: any) => {
    const newMonth = value;
    setSelectedMonth(newMonth);
    setCurrentDate(new Date(selectedYear, newMonth)); // Update the calendar with selected month
  };

  const clickMonthChange = (e: any) => {
    const newMonth = e;
    const newYear = new Date(currentDate.getFullYear(), newMonth).getFullYear();
    if (newYear <= new Date().getFullYear()) {
      setSelectedMonth(newMonth === -1 ? 11 : newMonth === 12 ? 0 : newMonth);
      setCurrentDate(new Date(currentDate.getFullYear(), newMonth));
      setSelectedYear(newYear);
    }
  };

  const handleYearChange2 = (value: any) => {
    const newYear = value;
    setSelectedYear2(newYear);
    setCurrentDate2(new Date(newYear, selectedMonth2)); // Update the calendar with selected year
  };

  const handleMonthChange2 = (value: any) => {
    const newMonth = value;
    setSelectedMonth2(newMonth);
    setCurrentDate2(new Date(selectedYear2, newMonth)); // Update the calendar with selected month
  };

  const clickMonthChange2 = (e: any) => {
    const newMonth = e;
    const newYear = new Date(
      currentDate2.getFullYear(),
      newMonth
    ).getFullYear();
    if (newYear <= new Date().getFullYear()) {
      setSelectedMonth2(newMonth === -1 ? 11 : newMonth === 12 ? 0 : newMonth);
      setCurrentDate2(new Date(currentDate2.getFullYear(), newMonth));
      setSelectedYear2(newYear);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const toggleOptions = () => {
    setIsOpenOptions(!isOpenOptions);
  };

  useEffect(() => {
    if (!isOpen) setIsOpenOptions(false);
  }, [isOpen]);

  const isPreviousMonthDisabled = (currentDate: any, currentDate2: any) => {
    const nextDate2 = new Date(currentDate2);
    nextDate2.setMonth(nextDate2.getMonth() - 1);
  
    return (
      nextDate2.getMonth() === currentDate.getMonth() &&
      nextDate2.getFullYear() === currentDate.getFullYear()
    );
  };

  const isNextMonthDisabled = (currentDate: any, currentDate2: any) => {
    const nextDate2 = new Date(currentDate);
    nextDate2.setMonth(nextDate2.getMonth() + 1);
  
    return (
      nextDate2.getMonth() === currentDate2.getMonth() &&
      nextDate2.getFullYear() === currentDate2.getFullYear()
    );
  };

  return (
    <div
      className={`w-full ${
        disabled ? "!text-[#BBB] hover:!bg-[#F7F7F7] hover:!cursor-default" : ""
      }`}
      ref={datepickerRef}
    >
      <div className="relative" >
        {datePickerQuantity === 2 ? (
          <div className={`flex group hover:bg-[#FFF3E5] rounded hover:cursor-pointer ${isOpen ? "outline outline-1 outline-[#FF861A]" : ""}`}>
            <div className="relative flex items-center">
              <input
                type="text"
                name="startDate"
                placeholder={placeholderStart}
                className={`group-hover:cursor-pointer text-sm w-[9.5rem] rounded-s border-r-0 border group-hover:bg-[#FFF3E5] group-hover:border-transparent py-2 pl-4 text-dark-2 outline-none transition focus:border-primary dark:border-dark-3 dark:text-dark-6 dark:focus:border-primary ${disabled ? "bg-[#F7F7F7]" : "bg-white"}`}
                value={updateInput()}
                disabled={disabled}
                onClick={toggleDatepicker}
                readOnly
              />
              <span className="absolute right-0">-</span>
            </div>
            <div className="relative flex items-center">
              <input
                type="text"
                name="endDate"
                placeholder={placeholderEnd}
                className={`group-hover:cursor-pointer text-sm w-[10.5rem] rounded-e border-l-0 border group-hover:bg-[#FFF3E5] group-hover:border-transparent py-2 pl-4 pr-8 text-dark-2 outline-none transition focus:border-primary dark:border-dark-3 dark:text-dark-6 dark:focus:border-primary ${disabled ? "bg-[#F7F7F7]" : "bg-white"}`}
                value={updateInput2()}
                disabled={disabled}
                onClick={toggleDatepicker}
                readOnly
              />
              <span
                className={`hidden sm:block absolute right-2 cursor-pointer text-[#808080] ${disabled ? "!text-[#BBB]" : "group-hover:text-[#FF861A]"}`}
                onClick={toggleDatepicker}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_10950_2245)">
                    <path
                      d="M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_10950_2245">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
        ) : (
          <div className="flex gap-2">
            <div className={`h-9 relative flex items-center group rounded hover:bg-[#FFF3E5] ${isOpen ? "outline outline-1 outline-[#FF861A]" : ""}`}>
              <input
                type="text"
                name="startDate"
                placeholder={placeholderStart}
                className="hover:cursor-pointer bg-white group-hover:bg-[#FFF3E5] group-hover:border-transparent text-sm md:text-sm w-full rounded border border-stroke py-2 pl-3 pr-8 alu-text-base-2 outline-none transition focus:border-primary dark:border-dark-3 dark:text-dark-6 dark:focus:border-primary"
                value={updateInput()}
                onClick={toggleDatepicker}
                readOnly
              />
              <span
                className="hidden sm:block absolute right-2 cursor-pointer text-[#808080] group-hover:text-[#FF861A]"
                onClick={toggleDatepicker}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_10950_2245)">
                    <path
                      d="M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_10950_2245">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
            <span className="m-auto">〜</span>
            <div className={`h-9 relative flex items-center group rounded hover:bg-[#FFF3E5] ${isOpen ? "outline outline-1 outline-[#FF861A]" : ""}`}>
              <input
                type="text"
                name="endDate"
                placeholder={placeholderEnd}
                className="hover:cursor-pointer bg-white group-hover:bg-[#FFF3E5] group-hover:border-transparent text-sm md:text-sm w-full rounded border border-stroke py-2 pl-3 pr-8 alu-text-base-2 outline-none transition focus:border-primary dark:border-dark-3 dark:text-dark-6 dark:focus:border-primary"
                value={updateInput2()}
                onClick={toggleDatepicker}
                readOnly
              />
              <span
                className="hidden sm:block absolute right-2 cursor-pointer text-[#808080] group-hover:text-[#FF861A]"
                onClick={toggleDatepicker}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_10950_2245)">
                    <path
                      d="M16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997L16.59 8.58997Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_10950_2245">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
        )}

        {isOpen && (
          <div
            className={`absolute top-[calc(100%+2px)] left-0 z-[1000] min-w-max p-6 rounded-lg border border-stroke bg-white shadow-lg dark:bg-dark-3`}
          >
            <div className="flex gap-6 mb-6">
              <div>
                <p className="text-sm alu-text-base-1 mb-4">日程を選択してください</p>
                <div className="flex items-center justify-evenly mb-4">
                  <button
                    className="rounded-full text-dark hover:bg-[#FFF3E5] dark:text-white dark:hover:bg-dark disabled:bg-transparent"
                    onClick={() => clickMonthChange(currentDate.getMonth() - 1)}
                  >
                    <svg
                      className="hover:fill-[#343A3D] fill-[#808080]"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z" />
                    </svg>
                  </button>

                  <div onClick={() => setYear1Open((prev) => !prev)} className={`${year1Open ? "outline outline-1 outline-[#FF861A] hover:bg-white" : ""} min-w-[6.875rem] relative flex justify-between items-center gap-1 rounded px-3 py-1 pr-1 group hover:cursor-pointer hover:bg-[#FFF3E5]`} onBlur={handleBlur} tabIndex={0}>
                    <div className="text-sm alu-text-base-2 font-normal">
                      {currentDate.getFullYear()}年{currentDate.getMonth() + 1}月
                    </div>
                    {year1Open && years.length > 0 && (
                      <ul className="z-[99] min-w-full rounded absolute top-[calc(100%+2px)] right-0 p-1 bg-white alu-options-box-shadow overflow-x-hidden overflow-y-scroll custom-scrollbar max-h-[10rem]">
                        {years.map((option: any, idx: number) => (
                          <li
                            tabIndex={0}
                            key={idx}
                            className="p-2 rounded flex items-center gap-2 hover:bg-[#FFF3E5] hover:cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleYearChange(option);
                              setYear1Open(false);
                            }}
                          >
                            {option === getYear(currentDate) ? (
                              <span className="shrink-0">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M8.9999 16.2001L4.7999 12.0001L3.3999 13.4001L8.9999 19.0001L20.9999 7.0001L19.5999 5.6001L8.9999 16.2001Z"
                                    fill="#FF861A"
                                  />
                                </svg>
                              </span>
                            ) : (
                              <span className="h-4 w-4 shrink-0"></span>
                            )}
                            <p className="flex-1 text-sm leading-6 font-normal alu-text-base-2">
                              {option}年
                            </p>
                          </li>
                        ))}
                      </ul>
                    )}
                    <span
                      onClick={(e) => {e.stopPropagation();setYear1Open((prev) => !prev)}}
                      className="hover:cursor-pointer group-hover:text-[#FF861A] text-[#343A3D] flex items-center justify-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_8858_2804)">
                          <path
                            d="M11.06 5.72656L8 8.7799L4.94 5.72656L4 6.66656L8 10.6666L12 6.66656L11.06 5.72656Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8858_2804">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>

                  <button
                    disabled={datePickerQuantity !== 1 &&  isNextMonthDisabled(currentDate, currentDate2)}
                    className="rounded-full text-dark hover:bg-[#FFF3E5] dark:text-white dark:hover:bg-dark disabled:bg-transparent"
                    onClick={() => clickMonthChange(currentDate.getMonth() + 1)}
                  >
                    <svg
                      className={`${datePickerQuantity !== 1 && isNextMonthDisabled(currentDate, currentDate2) ?
                        "fill-[#BBB]" : "hover:fill-[#343A3D] fill-[#808080]"}`}
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path d="M8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6L8.58984 7.41Z" />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-7">
                  {["日", "月", "火", "水", "木", "金", "土"].map((day) => (
                    <div
                      key={day}
                      className="flex items-center justify-center w-[36px] h-[36px] text-center text-sm font-medium text-secondary-color"
                    >
                      {day}
                    </div>
                  ))}
                </div>

                <div className="grid grid-cols-7 gap-y-0.5">
                  {renderCalendar({
                    year: selectedYear,
                    month: selectedMonth,
                  })}
                </div>
              </div>

              {datePickerQuantity === 2 && (
                <div>
                  <p className="text-sm alu-text-base-1 mb-4 invisible">日程を選択してください</p>
                  <div className="flex items-center justify-evenly mb-4">
                    <button
                      disabled={isPreviousMonthDisabled(currentDate, currentDate2)}
                      className="rounded-full text-dark hover:bg-[#FFF3E5] dark:text-white dark:hover:bg-dark disabled:hover:bg-transparent"
                      onClick={() =>
                        clickMonthChange2(currentDate2.getMonth() - 1)
                      }
                    >
                      <svg
                        className={`${
                          isPreviousMonthDisabled(currentDate, currentDate2)
                            ? "fill-[#BBB]"
                            : "hover:fill-[#343A3D] fill-[#808080]"
                        }`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z" />
                      </svg>
                    </button>

                    <div onClick={() => setYear2Open((prev) => !prev)} className={`${year2Open ? "outline outline-1 outline-[#FF861A] hover:bg-white" : ""} min-w-[6.875rem] relative flex justify-between items-center gap-1 rounded px-3 py-1 pr-1 group hover:cursor-pointer hover:bg-[#FFF3E5]`} onBlur={handleBlur2} tabIndex={0}>
                      <div className="text-sm alu-text-base-2 font-normal">
                        {currentDate2.getFullYear()}年{currentDate2.getMonth() + 1}月
                      </div>
                      {year2Open && years.length > 0 && (
                        <ul className="z-[99] min-w-full rounded absolute top-[calc(100%+2px)] right-0 p-1 bg-white alu-options-box-shadow overflow-x-hidden overflow-y-scroll custom-scrollbar max-h-[10rem]">
                          {years.map((option: any, idx: number) => (
                            <li
                              tabIndex={0}
                              key={idx}
                              className="p-2 rounded flex items-center gap-2 hover:bg-[#FFF3E5] hover:cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleYearChange2(option);
                                setYear2Open(false);
                              }}
                            >
                              {option === getYear(currentDate2) ? (
                                <span className="shrink-0">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.9999 16.2001L4.7999 12.0001L3.3999 13.4001L8.9999 19.0001L20.9999 7.0001L19.5999 5.6001L8.9999 16.2001Z"
                                      fill="#FF861A"
                                    />
                                  </svg>
                                </span>
                              ) : (
                                <span className="h-4 w-4 shrink-0"></span>
                              )}
                              <p className="flex-1 text-sm leading-6 font-normal alu-text-base-2">
                                {option}年
                              </p>
                            </li>
                          ))}
                        </ul>
                      )}
                      <span
                        onClick={(e) => {e.stopPropagation();setYear2Open((prev) => !prev)}}
                        className="hover:cursor-pointer group-hover:text-[#FF861A] text-[#343A3D] flex items-center justify-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_8858_2804)">
                            <path
                              d="M11.06 5.72656L8 8.7799L4.94 5.72656L4 6.66656L8 10.6666L12 6.66656L11.06 5.72656Z"
                              fill="currentColor"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_8858_2804">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </div>

                    <button
                      className="rounded-full text-dark hover:bg-[#FFF3E5] dark:text-white dark:hover:bg-dark disabled:bg-transparent"
                      onClick={() =>
                        clickMonthChange2(currentDate2.getMonth() + 1)
                      }
                    >
                      <svg
                        className="hover:fill-[#343A3D] fill-[#808080]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6L8.58984 7.41Z" />
                      </svg>
                    </button>
                  </div>

                  <div className="grid grid-cols-7">
                    {["日", "月", "火", "水", "木", "金", "土"].map((day) => (
                      <div
                        key={day}
                        className="flex items-center justify-center w-[36px] h-[36px] text-center text-sm font-medium text-secondary-color"
                      >
                        {day}
                      </div>
                    ))}
                  </div>

                  <div className="grid grid-cols-7 gap-y-0.5">
                    {renderCalendar({
                      year: selectedYear2,
                      month: selectedMonth2,
                    })}
                  </div>
                </div>
                )}
            </div>

            <div className="flex items-center justify-between space-x-2.5">
              <CustomButton
                id="cancelButton"
                variant="text"
                onClick={handleCancel}
              >
                キャンセル
              </CustomButton>
              <div className="flex items-center gap-4">
                <CustomButton disabled={disabled || !selectedEndDate || !selectedStartDate} variant="text" type="button" 
                  onClick={handleClear}>
                  選択を解除
                </CustomButton>
                <CustomButton
                  id="applyButton"
                  size="md"
                  onClick={handleApply}
                  disabled={!selectedEndDate || !selectedStartDate}
                >
                  確定
                </CustomButton>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
